import request from '../utils/request';
let token = window.localStorage.getItem('token')
// let systemManagementServer = 'http://crm3000.cm-qa.devlb.jsxfedu.net'
// let ebookServer = 'http://ebookserver8080.cm-qa.devlb.jsxfedu.net'
// let systemManagementServer = 'http://10.4.70.148:10001'
let systemManagementServer = ''
// let ebookServer = ''
if (location.host.includes('qalb.jsxfedu.net')) {
    systemManagementServer = 'https://jsxf-gateway-qa.qalb.jsxfedu.net'
} else {
    systemManagementServer = location.protocol + '//cegw.bnupg.com'
}
// systemManagementServer = 'http://jsxf-gateway-qa.qalb.jsxfedu.com'
// function jsonToQuery(json) {
//     return Object.keys(json)
//         .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(json[key])}`)
//         .join('&')
// }
// 课本首页
export const getBookInfo = query => {
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/index/book-info',
        method: 'get',
        params: query
    });
};
export const getGoodsInfo = query => {
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/index/goods-info',
        method: 'get',
        params: query
    });
};
// 练一练
export const getBookQuestions = query => { // 用户图书题目
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/index/book-questions',
        method: 'get',
        params: query
    });
};
export const updateBookProgress = data => { // 用户图书进度变更
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/index/book-progress-update',
        method: 'post',
        data: data
    });
};
export const submitQuestion = data => { // 练一练答题
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/index/question-submit',
        method: 'post',
        data: data
    });
};
export const shuffleQuestion = data => { // 重新乱序小题
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/index/shuffle-one-question',
        method: 'post',
        data: data
    });
};
// 趣配音
export const getBookDubbing = query => {
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/index/book-dubbing',
        method: 'get',
        params: query
    });
};
export const getBookDubInfo = query => { // 图书信息
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/work/bookInfo',
        method: 'get',
        params: query
    });
};
export const getLikeStatus = query => { // 获取点赞状态
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/work/getLikeStatus',
        method: 'get',
        params: query
    });
};
export const getHighLikeWork = query => { // 获取高赞配音作品
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/work/highLikeWork',
        method: 'get',
        params: query
    });
};
export const getMyWork = query => { // 我的配音作品
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/work/myWork',
        method: 'get',
        params: query
    });
};
export const getEval = query => { // 获取评测结果
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/eval/getEval',
        method: 'get',
        params: query
    });
};
export const saveEval = data => { // 保存评测结果
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/eval/saveEval',
        method: 'post',
        data: data
    });
};
export const likeWork = data => { // 点赞
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/work/like',
        method: 'post',
        data: data
    });
};
export const deleteWork = data => { // 删除作品
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/work/delete',
        method: 'post',
        data: data
    });
};
// 批量获取文件下载地址
export const postBatchFileUrl = data => {
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/rs/post-batch-file-url',
        method: 'post',
        // headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        // data: jsonToQuery(data)
        data: data
    });
};
// export const cdManagerOutStock = data => {
//     return request({
//         url: systemManagementServer + '/disk/out-of-stock',
//         method: 'post',
//         data: data
//     });
// };
// export const logout = data => {
//     return request({
//         url: systemManagementServer + '/logout',
//         method: 'post',
//         data: data
//     });
// };

// 登录
export const postLogin = data => {
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/user/login',
        method: 'post',
        data: data
    });
};

// 检验是否是新用户
export const userCheck = query => {
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/user/check',
        method: 'get',
        params: query
    });
};

// 获取验证码
export const sendPhoneCode = data => {
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/user/send-phone-code',
        method: 'post',
        data: data
    });
};
// 获取用户信息
export const getUserInfo = query => {
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/user/current',
        method: 'get',
        params: query,
        headers: {'token': token},
    });
};

// 获取用户信息
export const getBookShelf = query => {
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/index/user-bookshelf',
        method: 'get',
        params: query,
        headers: {'token': token},
    });
};

// 获取资源路径
export const getFileUrl = query => {
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/rs/get-file-url',
        method: 'get',
        params: query,
        headers: {'token': token},
    });
};

export const uploadSign = query => {
    return request({
        url: systemManagementServer + '/jsxf-climbing-english/rs/uploadSign',
        method: 'get',
        params: query,
    });
};
